import { EDrawingActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const startDrawing = actionGenerator<EDrawingActionType.DrawingStarted>(EDrawingActionType.DrawingStarted);
